<template>
    <div class="dropdown">  
        <a href="#/" class="button-dropdown" @mousedown="isOpen = !isOpen" v-if="!isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"/></svg>
        </a>
        <a href="#/" class="button-dropdown" @mousedown="isOpen = !isOpen" v-if="isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"/></svg>
        </a>
        <transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen && secondTime">
                <div v-for="(item,i) in items" :key="i" class="menu-item1">
                    <a :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#000 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop{
        background-color: #fff;
        width:300px !important;
        height: 350px !important;
        z-index: 99;
        box-shadow: -5px 4px 12px rgb(0 0 0 / 21%);
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 1% 0;
        margin-top: 20px;
        overflow: scroll;
        overflow-x: hidden;
    }
 

   
    .sidebar-drop .menu-item1 {
        color:#686fcf;
        font-size: 20px;
        padding: 20px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#000;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }

     .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #000;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#000;     
    }

    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.7s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>